
import coretips from './tips/index'
import nmcConfig from '../config/config';
import util from '../utils/util'
var flashTime = null, //小黄条延时
    loadingTime = null, //加载器延时
    reqMaxTime = null; //子业务请求时间延时
var tips = {
    enableLoading: 1,
    isLoading: 0,
    manualReqNum: 0,
    /**
      * 小黄条提示
      * @method flash
      * @param  {String} str 提示内容
      * @param  {String} type 类型
      * @param  {Int}    duration 持续时间
      * @author evanyuan
      */
    flash: function (str, type, duration) {
        if (!str) return;
        var _self = this,
            icoClass = "";
        !duration && (duration = 4000);
        icoClass =
            type === "success" ? "top-alert-icon-done" : "top-alert-icon-waring";
        _self.showFlash(str, icoClass);
        flashTime = setTimeout(function () {
            _self.hideFlash(1);
        }, duration);
    },
    /**
     * 显示小黄条
     * @method showFlash
     * @param  {String} str 提示内容
     * @param  {String} icoClass 图标class (top-alert-icon-waring top-alert-icon-done top-alert-icon-doing)
     * @author evanyuan
     */
    showFlash: function (str, icoClassName) {

        clearTimeout(flashTime);
        flashTime = null;
        var topAlert = $("#topAlert");
        var flashMsg = $("#flashMsg");
        if (!flashMsg.length) {
            topAlert = $("<div/>")
                .addClass("top-alert")
                .attr("id", "topAlert")
                .css({
                    "z-index": 1100,
                    "margin-left": "-200px"
                });
            flashMsg = $("<span/>").attr("id", "flashMsg");
            topAlert.append(flashMsg);
            topAlert.appendTo("body");
        }
        topAlert.show();
        flashMsg
            .html(str)
            .show()
            .attr("class", icoClassName + " fade-in");
    },
    //隐藏小黄条
    hideFlash: function (fromTiming) {
        var _self = this;
        var _hideTip = function () {
            flashTime = null;
            var topAlert = $("#topAlert");
            var flashMsg = $("#flashMsg");
            if (!flashMsg.length || flashMsg.hasClass("fade-out")) {
                return;
            }
            util.animationend(flashMsg[0], function () {
                !flashTime && flashMsg.html("").hide();
                !flashTime && topAlert.hide();
            });
            flashMsg.removeClass("fade-in").addClass("fade-out");
        };
        if (fromTiming) {
            _hideTip();
        } else {
            //从loading过来场景, 有其他提示存在则不隐藏
            !flashTime && _hideTip();
        }
    },
    //立即隐藏小黄条
    hideFlashNow: function () {
        $("#flashMsg")
            .hide()
            .html("");
        $("#topAlert").hide();
    },
    /**
     * 初始化全局加载提示
     * @method initLoading
     * @author evanyuan
     */
    initLoading: function () {
        var _self = this,
            $doc = $(document);
        $doc.ajaxStart(function () {
            _self.ajaxLoading = 1;
            !_self.manualReqNum && _self._loadingStart();
        });
        $doc.ajaxStop(function () {
            _self.ajaxLoading = 0;
            !_self.manualReqNum && _self._loadingStop();
        });
    },
    _loadingStart: function (opt) {
        var _self = this,
            delay = 800;
        if (_self.enableLoading) {
            clearTimeout(loadingTime);
            _self.isLoading = 1;
            loadingTime = setTimeout(function () {
                var flashMsg = $("#flashMsg");
                //有其他提示存在, 不提示loading
                if (flashMsg.length && flashMsg.html()) {
                    return;
                }
                if (_self.isLoading) {
                    _self.showLoading(opt);
                }
            }, delay);
        }
    },
    _loadingStop: function () {
        var _self = this;
        setTimeout(function () {
            if (_self.enableLoading && !_self.manualReqNum && !_self.ajaxLoading) {
                _self.stopLoading();
            }
        }, 0);
    },
    //显示loading
    showLoading: function (opt) {
        opt = opt || {};
        this.showFlash(
            opt.text || nmcConfig.loadingWord,
            opt.className || "top-alert-icon-doing"
        );
    },
    //停止加载状态
    stopLoading: function () {
        this.isLoading = 0;
        this.hideFlash();
    },
    //手动的请求计数, 用于接入业务jsonp方式等复用loading逻辑
    requestStart: function (opt) {
        opt = opt || {};
        var _self = this,
            delayHide = 5000;
        if (typeof opt.delayHide != "undefined" && !isNaN(opt.delayHide)) {
            delayHide = parseInt(opt.delayHide, 10);
        }
        this.manualReqNum++;
        if (this.manualReqNum == 1 && !this.ajaxLoading) {
            this._loadingStart(opt);
            clearTimeout(reqMaxTime);
            reqMaxTime = setTimeout(function () {
                if (_self.manualReqNum > 0) {
                    _self.manualReqNum = 0;
                    _self._loadingStop();
                }
            }, delayHide);
        }
    },
    requestStop: function () {
        this.manualReqNum--;
        if (this.manualReqNum < 0) {
            this.manualReqNum = 0;
        }
        if (this.manualReqNum == 0 && !this.ajaxLoading) {
            this._loadingStop();
        }
    }
}
let ret = {};
Object.assign(ret, coretips, tips);

export default ret;